import React from 'react';

function Spinner() {
  return (
    <div className="fc-loader">
      <div className="spinner" />
    </div>
  );
}

export default Spinner;
